module.exports = __webpack_public_path__ + "static/media/bbtsaxcBackground.5abaf9d1.png";